import { ApplicationActions, ApplicationActionType } from './actions';

interface ApplicationState {
	isLoggingOut: boolean;
	softResetApplication: boolean;
}

const defaultApplicationState: ApplicationState = {
	isLoggingOut: false,
	softResetApplication: false
};

export function applicationResetReducers(
	state: ApplicationState = defaultApplicationState,
	action: ApplicationActions
): ApplicationState {
	const { type } = action;

	switch (type) {
	case ApplicationActionType.HardReset:
		return {
			...defaultApplicationState,
			isLoggingOut: true
		};
	case ApplicationActionType.Reset:
		return {
			...state,
			softResetApplication: true
		};
	case ApplicationActionType.ResetComplete:
		return {
			...state,
			softResetApplication: false
		};
	case ApplicationActionType.SoftReset:
		return {
			...defaultApplicationState
		};
	default:
		return state;
	}
}
